<!--
 * @Description: 设备量走势
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-11-20 09:57:11
 * @LastEditTime: 2022-11-30 16:49:50
-->
<template>
<div class="statisticalChartsContainer">
  <!-- 设备量走势 -->
  <div class="chartItem">
    <div class="itemBox">
      <div class="chartBox">
        <echarts :chart-id="idName" :chart-option="options" v-if="isShow"></echarts>
        <img src="../../assets/img/bigScreen/noData.png" alt="" v-else>
        <!-- <el-empty :image="imgSrc" :image-size="80" description="暂无设备量走势" v-else></el-empty> -->
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as echarts from 'echarts'
var dayjs = require('dayjs')
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
    big: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      imgSrc: require('../../assets/img/bigScreen/no-data.png'),
      isShow: true,
      options: {
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          top: '8%',
          left: '8%',
          right: '8%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: {
              color: '#14E2C1'
            },
            axisLine: {
              lineStyle: {
                color: '#0B3363'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#16263D'
              }
            },
            axisTick: { show: false }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#14E2C1'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#16263D'
              }
            },
          }
        ],
        color: ['#14E5C4', '#A8740C', '#3096C6', '#D43067', '#FFEA00', '#13DA93', '#ff0000'],
        series: [
          {
            name: '',
            type: 'line',
            stack: 'Total',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0, color: '#14E5C4' // 0% 处的颜色
                }, {
                    offset: 1, color: 'rgba(255,255,255,0)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            smooth: true,
            data: []
          }
        ]
      },
      seriesData: {
        name: '',
        type: 'line',
        // stack: 'Total',
        showSymbol: false,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: '#14E5C4' },
              { offset: 1, color: 'rgba(255,255,255,0)' }
            ],
            global: false
          }
        },
        smooth: true,
        data: []
      }
    }
  },
  //数据自动刷新，必然需要一个监听机制告诉Echarts重新设置数据
  /* watch: {
    //观察option的变化
    options: {
      handler(newVal, oldVal) {
        if (this.myChart1) {
          if (newVal) {
            this.myChart1.setOption(newVal);
          } else {
            this.myChart1.setOption(oldVal);
          }
        } else {
          this.init();
        }
      },
      deep: true //对象内部属性的监听，关键。
    },
  }, */
  computed: {
    idName() {
      return this.flag ? "echartsId2_big" : "echartsId2"
    },
    styleObj(){
      return this.flag ? {
          fontSize:20
      }:{
        fontSize:12
      }
    }
  },
  created() {
    this.initStyle()
    this.getEchartList()
  },
  mounted() {
/*     window.onresize = () => {
      this.init()
    } */
  },
  methods: {
   /*   init() {
      console.log(`this.idName`, this.idName)
      let myChart1 = echarts.init(document.getElementById(this.idName))
      myChart1.setOption(this.options, true)
    }, */
    async getEchartList() {
      let { code, msg, data } = await this.request.post('/front/device/install7DayStatistics')
      // 模拟数据
      // let { code, msg, data } = {"code":200,"msg":"success","data":[{"deviceTypeId":93,"deviceTypeName":"电气火灾设备","itemList":[{"typeId":93,"typeName":"电气火灾设备","day":"2021-11-13","num":0},{"typeId":93,"typeName":"电气火灾设备","day":"2021-11-14","num":0},{"typeId":93,"typeName":"电气火灾设备","day":"2021-11-15","num":4},{"typeId":93,"typeName":"电气火灾设备","day":"2021-11-16","num":14},{"typeId":93,"typeName":"电气火灾设备","day":"2021-11-17","num":0},{"typeId":93,"typeName":"电气火灾设备","day":"2021-11-18","num":0},{"typeId":93,"typeName":"电气火灾设备","day":"2021-11-19","num":0}]}]}
      let options = { ...this.options }
      let color = ['#14E5C4', '#A8740C', '#3096C6', '#D43067', '#FFEA00', '#13DA93', '#ff0000']

      // 处理异常情况
      if (code != 200) {

        if (code == 500) {
          // options.xAxis[0].axisLine.lineStyle.width = 0
          // options.yAxis[0].axisLine.lineStyle.width = 0
          // options.graphic[0].children[0].style.text = ['没有找到您要查询的相关数据']
          // this.options = options
          this.isShow = false
          return this.$message.error(msg)
        }
        return
      }
      if(data == null || data.length < 1){
        // this.isShow = false
        // 没数据时建造假数据
        let day1 = dayjs().format('YYYY-MM-DD')
        let day2 = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
        let day3 = dayjs().subtract(2, 'day').format('YYYY-MM-DD')
        let day4 = dayjs().subtract(3, 'day').format('YYYY-MM-DD')
        let day5 = dayjs().subtract(4, 'day').format('YYYY-MM-DD')
        let day6 = dayjs().subtract(5, 'day').format('YYYY-MM-DD')
        let day7 = dayjs().subtract(6, 'day').format('YYYY-MM-DD')

        data = [
          {
            deviceTypeName: '设备',
            itemList: [
              { day: day1, num: 0 },
              { day: day2, num: 0 },
              { day: day3, num: 0 },
              { day: day4, num: 0 },
              { day: day5, num: 0 },
              { day: day6, num: 0 },
              { day: day7, num: 0 }
            ]
          }
        ]
        // return
      }


      // 解析数据
      let xAxisData = []
      let seriesData = []
      seriesData = data.map(({ deviceTypeName, itemList}, i) => {
        let item = JSON.parse(JSON.stringify(this.seriesData))
        let xData = []
        item.name = deviceTypeName
        item.areaStyle.color.colorStops[0].color = color[i] || 'red'
        item.data = itemList.map(({ day, num }) => {
          let days = day.substr(5)
          i == 0 && xAxisData.push(days)
          return num
        })
        return item
      })

      options.xAxis[0].data = xAxisData
      options.series = seriesData
      this.options = options
      // this.initConfig(legendData, yData)
    },
    // initConfig(legendData, yData) {
    //   // console.log(legendData)
    //   this.options.legend.data = legendData
    //   let itemitem = []
    //   yData.forEach((item, i) => {
    //     let dataY=[]
    //     item.forEach(val=>{
    //       dataY.push(val.num)
    //     })
    //     itemitem.push({
    //       name: legendData[i],
    //       type: 'line',
    //       stack: '总量',
    //       symbolSize: 8,
    //       label: {
    //         normal: {
    //           show: false,
    //           position: 'top'
    //         }
    //       },
    //       itemStyle: {
    //         normal: {
    //           areaStyle: {
    //             //color: '#94C9EC'
    //             color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
    //               offset: 0,
    //               color: 'rgba(7,44,90,0.3)'
    //             }, {
    //               offset: 1,
    //               color: 'rgba(0,146,246,0.9)'
    //             }]),
    //           }
    //         }
    //       },
    //       data: dataY
    //     })
    //   })
    //   this.options.series = []
    //   // console.log(itemitem);
    //   this.options.series=[...itemitem]
    // },
    initStyle(){
      this.options.xAxis[0].axisLabel.fontSize = this.styleObj.fontSize
      this.options.yAxis[0].axisLabel.fontSize = this.styleObj.fontSize
    },
  }
}
</script>

<style lang="scss" scoped>
.statisticalChartsContainer {
  // font-size: 0;
  // text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  // border: 1px solid red;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;

  .chartItem {
    width: 100%;
    height: 100%;

    .itemBox {
      width: 100%;
      height: 100%;

      .chartBox {
        width: 100%;
        height: 100%;
        >img {
          width: 90%;
          height: 90%;
          margin: 5%;
        }
        // background: rgba(29, 55, 82, 0.85);
      }
    }
  }
}
</style>
